import {
  projectItems,
  projectDelete,
  projectDetails,
  projectCreate,
  projectCreateEmp,
  projectDeleteEmp,
  projectEmpRules,
  projectRules
} from '@/api/project'

const project = {
  state: {

  },
  mutations: {

  },
  actions: {
    ProjectRules ({ commit }, data) {
      return new Promise((resolve, reject) => {
        projectRules(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    ProjectEmpRules ({ commit }, data) {
      return new Promise((resolve, reject) => {
        projectEmpRules(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    ProjectItems ({ commit }, data) {
      return new Promise((resolve, reject) => {
        projectItems(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    ProjectDelete ({ commit }, data) {
      return new Promise((resolve, reject) => {
        projectDelete(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    ProjectDetails ({ commit }, data) {
      return new Promise((resolve, reject) => {
        projectDetails(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    ProjectCreate ({ commit }, data) {
      return new Promise((resolve, reject) => {
        projectCreate(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    ProjectCreateEmp ({ commit }, data) {
      return new Promise((resolve, reject) => {
        projectCreateEmp(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    ProjectDeleteEmp ({ commit }, data) {
      return new Promise((resolve, reject) => {
        projectDeleteEmp(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default project



// WEBPACK FOOTER //
// ./src/store/modules/project.js